/*! LQ NameSpace | Copyright 2015 Loto Quebec Inc. */
/*global jQuery,lq,console*/
/*jshint -W030*/
; (function ($, document, window, lq) {
	'use strict';


	$('.card.galerie').each(function () {
		var cardGalerie = $(this);
		var primaryColor = cardGalerie.data('buttonprimarycolor');
		var secondaryColor = cardGalerie.data('buttonsecondarycolor');

		if (primaryColor && secondaryColor) {
			$('.btnContainer', this).attr('style', 'background-image: linear-gradient(140deg, ' + primaryColor + ', ' + secondaryColor + ');');
		} else if(primaryColor) {
			$('.btnContainer', this).attr('style', 'background-color: ' + primaryColor + ';');
		}

	});
	// Update global scope lq namespace
	window.lq = lq;

	// Auto trigger all self implemented (plugin) functionalities
	lq.load.push(
		"lq.utils",
		[
			'setupCardsGalerie'
		]
	);

}(jQuery, document, window, (window.lq || {})));